import React, { createContext, useState, useContext } from 'react';
import apiService from '../services/apiService';

const transformProjects = (projects) => {
  if (!Array.isArray(projects)) return [];
  return projects.map((project) => {
    const { _id, members = [], ...rest } = project;
    return { id: _id, members, ...rest };
  });
};

const transformProject = (pro) => {
  const { _id, members = [], ...rest } = pro;
  return { id: _id, members, ...rest };
};

// Create the context
const ProjectsContext = createContext();

// Create a custom hook for easier access
export const useProjects = () => {
  return useContext(ProjectsContext);
};

// Export the provider to wrap around the app
export const ProjectsProvider = ({ children }) => {
  const [projects, setProjects] = useState([]);

  // Function to add a new project
  const addProject = async (project) => {
    const { data } = await apiService.post('/api/v1/project', project);
    setProjects((prevProjects) => [...prevProjects, transformProject(data)]);
  };

  // Function to remove a project by id
  const removeProject = async (id) => {
    await apiService.delete(`/api/v1/project/${id}`, {
      params: { id },
    });
    setProjects((prevProjects) =>
      prevProjects.filter((project) => project.id !== id)
    );
  };

  // Function to update a project
  const updateProject = async (updatedProject) => {
    await apiService.patch(
      `/api/v1/project/${updatedProject.id}`,
      updatedProject
    );
    setProjects((prevProjects) =>
      prevProjects.map((project) =>
        project.id === updatedProject.id ? updatedProject : project
      )
    );
  };

  // Function to fetch projects (could be from an API)
  const fetchProjects = async () => {
    const { data } = await apiService.get('/api/v1/project');
    setProjects(transformProjects(data || []));
  };

  const getProjectById = (id) => {
    const project = projects.find((it) => it?.id === id);
    return project;
  };

  return (
    <ProjectsContext.Provider
      value={{
        projects,
        addProject,
        removeProject,
        updateProject,
        fetchProjects,
        getProjectById,
      }}>
      {children}
    </ProjectsContext.Provider>
  );
};
